"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polygon = exports.base = exports.arbitrum = exports.optimism = exports.ethereum = void 0;
exports.ethereum = {
    mainnet: {
        connectorAddress: "0xFA1B28052Bd8087B1CF64eE9429FEB324e95B0ff",
    },
    testnet: {
        connectorAddress: "0x76345af0Dc5EcC7D1c8bFe9cB5Dcf78C3EEc93A4",
    },
};
exports.optimism = {
    mainnet: {
        connectorAddress: "0xec4A7D93750BbcE2A07fd1bc748507ea645e9d52",
    },
    testnet: {
        connectorAddress: "",
    },
};
exports.arbitrum = {
    mainnet: {
        connectorAddress: "0xec4A7D93750BbcE2A07fd1bc748507ea645e9d52",
    },
    testnet: {
        connectorAddress: "",
    },
};
exports.base = {
    mainnet: {
        connectorAddress: "0xec4A7D93750BbcE2A07fd1bc748507ea645e9d52",
    },
    testnet: {
        connectorAddress: "",
    },
};
exports.polygon = {
    mainnet: {
        connectorAddress: "0xE0166434A2ad67536B5FdAFCc9a6C1B41CC5e085",
    },
    testnet: {
        connectorAddress: "",
    },
};
//# sourceMappingURL=connector-address.js.map